export default __webpack_public_path__ + "static/media/REFACCIONARIO.ef1203a4.jpg";